
export default function Investimento() {
  const handleCheckout = () => {
    window.open('https://wa.me/5586988088824?text=Quero Fazer a Matricula No Freedom Experience', '_blank');
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/5586988088824?text=Olá! Tenho interesse no curso IA KIDS', '_blank');
  };

  const courses = [
    {
      name: 'IA Kids – Hackeando o Futuro com Inteligência Artificial',
      price: 'R$ 1.000,00',
      duration: '6h - 2x por semana durante 3 semanas'
    },
    {
      name: 'Bitcoin e Dinheiro do Futuro – O Jogo da Liberdade',
      price: 'R$ 1.000,00',
      duration: '6h - 2x por semana durante 3 semanas'
    },
    {
      name: 'O Poder da Palavra – Comunicação, Persuasão e Conexão e Oratória',
      price: 'R$ 1.000,00',
      duration: '6h - 2x por semana durante 3 semanas'
    },
    {
      name: 'Projeto de Vida – Quem você quer ser quando crescer?',
      price: 'R$ 1.000,00',
      duration: '6h - 2x por semana durante 3 semanas'
    },
    {
      name: 'Corpo e Mente e Espírito e Superação Pessoal',
      price: 'R$ 1.000,00',
      duration: '6h - 2x por semana durante 3 semanas'
    },
    {
      name: 'Curso de Xadrez',
      price: 'R$ 600,00',
      duration: '6h - 2x por semana durante 3 semanas'
    },
    {
      name: 'Curso de Memória',
      price: 'R$ 400,00',
      duration: '4h - 2x por semana durante 2 semanas'
    },
    {
      name: 'Curso de Cubo Mágico',
      price: 'R$ 400,00',
      duration: '4h - 2x por semana durante 2 semanas'
    }
  ];

  return (
    <section id="investimento" className="relative py-16 md:py-32 overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-0 left-1/4 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-neon-blue/20 rounded-full blur-[100px] md:blur-[150px] animate-pulse-slow"></div>
      <div className="absolute bottom-0 right-1/4 w-[400px] md:w-[600px] h-[400px] md:h-[600px] bg-neon-purple/20 rounded-full blur-[100px] md:blur-[150px] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-10 md:mb-16 space-y-4 md:space-y-6">
            <div className="inline-flex items-center gap-2 px-3 md:px-4 py-2 rounded-full bg-neon-blue/10 border border-neon-blue/30 backdrop-blur-sm">
              <i className="ri-price-tag-3-fill text-neon-blue text-sm md:text-base"></i>
              <span className="text-neon-blue text-xs md:text-sm font-semibold tracking-wide">INVESTIMENTO</span>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight px-4">
              Garanta o Futuro do Seu Filho
              <span className="block bg-gradient-to-r from-neon-blue to-neon-purple bg-clip-text text-transparent mt-2"> Agora</span>
            </h2>
          </div>

          {/* Course List */}
          <div className="mb-10 md:mb-16">
            <div className="bg-dark-800/60 backdrop-blur-xl border border-neon-blue/30 rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-10">
              <div className="text-center mb-6 md:mb-8">
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-3 md:mb-4">Cursos Disponíveis</h3>
                <p className="text-gray-300 text-base md:text-lg">Matricule-se em um curso específico ou no pacote completo</p>
              </div>

              <div className="grid gap-3 md:gap-4 mb-6 md:mb-8">
                {courses.map((course, index) => (
                  <div key={index} className="bg-dark-900/50 border border-neon-blue/20 rounded-xl p-4 md:p-5 hover:border-neon-blue/40 transition-all duration-300">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
                      <div className="flex-1">
                        <h4 className="text-white font-semibold text-sm md:text-lg mb-1 md:mb-2">{course.name}</h4>
                        <p className="text-gray-400 text-xs md:text-sm">{course.duration}</p>
                      </div>
                      <div className="text-neon-blue font-bold text-lg md:text-xl lg:text-right">
                        {course.price}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="bg-gradient-to-r from-neon-blue/10 to-neon-purple/10 border border-neon-blue/40 rounded-xl p-4 md:p-6 text-center">
                <p className="text-white text-base md:text-lg">
                  Se você comprar todos os cursos individualmente fica{' '}
                  <span className="text-neon-blue font-bold text-xl md:text-2xl">R$ 7.400,00</span>
                </p>
              </div>
            </div>
          </div>

          {/* Pricing Card */}
          <div className="relative">
            {/* Main Card */}
            <div className="relative bg-dark-800/80 backdrop-blur-xl border-2 border-neon-blue/40 rounded-3xl md:rounded-[3rem] p-6 md:p-12 lg:p-16 shadow-[0_0_60px_rgba(0,212,255,0.4)] md:shadow-[0_0_100px_rgba(0,212,255,0.4)]">
              {/* Popular Badge */}
              <div className="absolute -top-4 md:-top-6 left-1/2 -translate-x-1/2 bg-gradient-to-r from-neon-blue to-neon-purple px-4 md:px-8 py-2 md:py-3 rounded-full shadow-[0_0_20px_rgba(0,212,255,0.6)] md:shadow-[0_0_30px_rgba(0,212,255,0.6)]">
                <p className="text-white font-bold text-sm md:text-lg whitespace-nowrap">
                  <i className="ri-fire-fill mr-2"></i>
                  VAGAS LIMITADAS
                </p>
              </div>

              <div className="space-y-6 md:space-y-10">
                {/* Price */}
                <div className="text-center space-y-4 md:space-y-6 pt-4 md:pt-6">
                  <div className="space-y-3 md:space-y-4">
                    <p className="text-base md:text-xl text-gray-300 mb-2 md:mb-3">
                      Se comprar o pacote completo ou curso integral fica de{' '}
                      <span className="line-through text-gray-500">R$ 7.400,00</span> por
                    </p>
                    <div className="flex items-center justify-center gap-2 md:gap-3 flex-wrap">
                      <span className="text-gray-400 text-xl md:text-3xl">12x de</span>
                      <span className="text-5xl md:text-7xl lg:text-8xl font-black text-neon-blue">R$ 500</span>
                    </div>
                    <div className="flex items-center justify-center gap-2 text-lg md:text-2xl text-gray-300 flex-wrap">
                      <span>ou</span>
                      <span className="text-neon-blue font-bold">R$ 5.000</span>
                      <span>à vista</span>
                    </div>
                  </div>
                </div>

                {/* Course Details */}
                <div className="space-y-4 md:space-y-6">
                  <div className="bg-gradient-to-r from-neon-blue/10 to-neon-purple/10 border border-neon-blue/30 rounded-xl md:rounded-2xl p-6 md:p-8 text-center">
                    <div className="flex items-center justify-center gap-2 md:gap-3 mb-3 md:mb-4 flex-wrap">
                      <i className="ri-map-pin-fill text-3xl md:text-4xl text-neon-blue"></i>
                      <h3 className="text-xl md:text-3xl font-bold text-white">Curso Presencial em Teresina</h3>
                    </div>
                    <div className="grid sm:grid-cols-2 gap-4 md:gap-6 mt-6 md:mt-8">
                      <div className="bg-dark-900/50 rounded-lg md:rounded-xl p-4 md:p-6 border border-neon-blue/20">
                        <div className="flex items-center justify-center gap-2 mb-2 md:mb-3">
                          <i className="ri-calendar-fill text-2xl md:text-3xl text-neon-blue"></i>
                          <p className="text-lg md:text-2xl font-bold text-white">Turma 1</p>
                        </div>
                        <p className="text-base md:text-xl text-neon-blue font-semibold">Dezembro 2024</p>
                      </div>
                      <div className="bg-dark-900/50 rounded-lg md:rounded-xl p-4 md:p-6 border border-neon-purple/20">
                        <div className="flex items-center justify-center gap-2 mb-2 md:mb-3">
                          <i className="ri-calendar-fill text-2xl md:text-3xl text-neon-purple"></i>
                          <p className="text-lg md:text-2xl font-bold text-white">Turma 2</p>
                        </div>
                        <p className="text-base md:text-xl text-neon-purple font-semibold">Janeiro 2025</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* CTA Buttons */}
                <div className="space-y-3 md:space-y-4 pt-4 md:pt-6">
                  <button 
                    onClick={handleCheckout}
                    className="w-full group relative px-6 md:px-8 py-4 md:py-6 bg-gradient-to-r from-neon-blue to-neon-purple rounded-xl md:rounded-2xl font-bold text-lg md:text-2xl text-white overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-[0_0_60px_rgba(0,212,255,0.8)] whitespace-nowrap cursor-pointer"
                  >
                    <span className="relative z-10 flex items-center justify-center gap-2 md:gap-3">
                      <i className="ri-rocket-2-fill text-2xl md:text-3xl"></i>
                      Garantir Minha Vaga Agora
                    </span>
                    <div className="absolute inset-0 bg-gradient-to-r from-neon-purple to-neon-blue opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </button>

                  <button 
                    onClick={handleWhatsApp}
                    className="w-full px-6 md:px-8 py-4 md:py-5 bg-dark-900/80 backdrop-blur-sm border-2 border-neon-blue/30 rounded-xl md:rounded-2xl font-bold text-base md:text-xl text-white hover:bg-dark-800 hover:border-neon-blue transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 md:gap-3"
                  >
                    <i className="ri-whatsapp-fill text-xl md:text-2xl text-neon-blue"></i>
                    Tirar Dúvidas no WhatsApp
                  </button>
                </div>

                {/* Trust Indicators */}
                <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 pt-4 md:pt-6 border-t border-neon-blue/10">
                  <div className="flex items-center gap-2 text-gray-300">
                    <i className="ri-lock-fill text-base md:text-xl text-neon-blue"></i>
                    <span className="text-xs md:text-sm">Pagamento Seguro</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-300">
                    <i className="ri-map-pin-2-fill text-base md:text-xl text-neon-purple"></i>
                    <span className="text-xs md:text-sm">Presencial em Teresina</span>
                  </div>
                </div>
              </div>

              {/* Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-neon-blue/5 to-neon-purple/5 rounded-3xl md:rounded-[3rem] pointer-events-none"></div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-6 md:-top-10 -left-6 md:-left-10 w-20 h-20 md:w-32 md:h-32 flex items-center justify-center">
              <div className="w-full h-full bg-neon-blue/30 rounded-full blur-[40px] md:blur-[60px]"></div>
            </div>
            <div className="absolute -bottom-6 md:-bottom-10 -right-6 md:-right-10 w-20 h-20 md:w-32 md:h-32 flex items-center justify-center">
              <div className="w-full h-full bg-neon-purple/30 rounded-full blur-[40px] md:blur-[60px]"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
